var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React from 'react';
import RTooltip from 'react-tooltip-lite';
var TOOLTIP_CLS = 'syl-tooltip';
var Tooltip = function (_a) {
    var _b;
    var children = _a.children, content = _a.content, getRef = _a.getRef, _c = _a.tipContentClassName, tipContentClassName = _c === void 0 ? '' : _c, rest = __rest(_a, ["children", "content", "getRef", "tipContentClassName"]);
    return (React.createElement(RTooltip, __assign({ content: content, arrowSize: 6, useDefaultStyles: false, tipContentClassName: classnames(TOOLTIP_CLS, (_b = {},
            _b[tipContentClassName] = tipContentClassName,
            _b)), padding: "8px 12px", zIndex: 1100, eventOff: 'onClick', ref: function (t) {
            getRef && getRef(t);
        } }, rest), children));
};
export { Tooltip, TOOLTIP_CLS };
//# sourceMappingURL=index.js.map